import React, { useState } from "react";
import { Collapse, Button } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { ChevronDown } from "react-feather";
import {
  Head,
  HeadLeft,
  HeadRight,
  BodyLeft,
  BodyRight,
  Wrapper,
  Body,
  HighlightColor,
  SecondaryColor,
} from "./styles";
import Results from "./Results";

const options = {
  maintainAspectRatio: false,
  responsive: true,
  cornerRadius: 2,
  indexAxis: "y",
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: () => "",
        beforeBody: (c) => `${c[0].raw} submissions`,
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        color: "black",
      },
      title: {
        display: false,
        text: "Count",
      },
    },

    x: {
      title: {
        display: true,
        text: "Submitted Answers",
      },
      ticks: {
        precision: 0,

        color: "black",
      },
    },
  },
};

const getStats = (question) => {
  const correctAnswer = question?.correctAnswer === "True" ? "true" : "false";

  const trueResponses = question?.answer_distribution?.true || 0;
  const falseResponses = question?.answer_distribution?.false || 0;

  const correctAnswers =
    correctAnswer === "true" ? trueResponses : falseResponses;

  return {
    correctAnswer,
    totalAnswers: trueResponses + falseResponses,
    correctAnswers,
    percentageCorrect: Math.ceil(
      (correctAnswers / (trueResponses + falseResponses)) * 100,
    ),
  };
};

const LabelArray = ["True", "False"];

const TrueFalse = ({ question }) => {
  const [open, setOpen] = useState(true);

  const { totalAnswers, correctAnswers, percentageCorrect, correctAnswer } =
    getStats(question);

  const data = {
    labels: LabelArray,
    datasets: [
      {
        label: "Submitted Options",
        data: [
          question?.answer_distribution?.true,
          question?.answer_distribution?.false,
        ],
        barPercentage: 0.5,
        borderRadius: 6,
        minBarLength: 2,

        borderWidth: 1,
        backgroundColor: LabelArray.map((label) =>
          label.toLowerCase() === correctAnswer
            ? HighlightColor
            : SecondaryColor,
        ),
        borderColor: "black",
        categoryPercentage: 0.9,
      },
    ],
  };

  return (
    <Wrapper $isOpen={open}>
      <Head onClick={() => setOpen((p) => !p)}>
        <HeadLeft>
          <span style={{ fontWeight: "600", fontSize: 12, color: "black" }}>
            Question {question.order + 1}
            <span
              style={{ color: "darkgrey", fontWeight: "400", paddingLeft: 2 }}
            >
              (True / False)
            </span>
          </span>
          <div style={{ height: 4 }} />
          <span
            style={{
              fontSize: 14,
              fontWeight: "400",
              color: "black",
              textAlign: "left",
            }}
          >
            {question?.question}
          </span>
        </HeadLeft>
        <HeadRight $isOpen={open}>
          <ChevronDown color="black" />
        </HeadRight>
      </Head>
      <Collapse in={open}>
        <div
          style={{
            background: "white",
            height: 100,
            width: "100%",
            padding: 8,
            borderBottom: "1px solid lightgray",
          }}
        >
          <span style={{ fontWeight: "500" }}>Options</span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              paddingTop: 8,
            }}
          >
            <Button
              variant="contained"
              style={{
                background:
                  correctAnswer === "true" ? HighlightColor : SecondaryColor,
                color: correctAnswer === "true" ? "white" : "black",
              }}
            >
              True
            </Button>
            <div style={{ width: 12 }} />
            <Button
              variant="contained"
              style={{
                background:
                  correctAnswer !== "true" ? HighlightColor : SecondaryColor,
                color: correctAnswer === "true" ? "black" : "white",
              }}
            >
              False
            </Button>
          </div>
        </div>
        <Body>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <BodyLeft>
              <span style={{ fontWeight: "500" }}>Responses Breakdown</span>
              <div style={{ height: 220, width: "100%" }}>
                <Bar options={options} data={data} />
              </div>
            </BodyLeft>
            <BodyRight>
              <Results
                totalAnswers={totalAnswers}
                correctAnswers={correctAnswers}
                percentageCorrect={percentageCorrect}
              />
            </BodyRight>
          </div>
        </Body>
      </Collapse>
    </Wrapper>
  );
};

export default TrueFalse;
